import { Pin } from 'lucide-react'
import { mutate } from '@/runtime'
import { Button } from './ui'

/**
 * The switch beside a project's title: pinned, it shows as an app on the phone.
 * A chip that is lit while pinned (a bare checkbox read as a form left open).
 * Unpinning drops the key. A workspace member may write Project in their
 * workspace, so it shows for them too.
 */
export const PinProject = ({ id, pinned }: { id: string; pinned: boolean }) => (
  <Button
    variant={pinned ? 'chipOn' : 'chip'}
    aria-pressed={pinned}
    onClick={() => void mutate.patch(id, { spec: { pinned: pinned ? null : true } })}
    className="shrink-0 mt-1"
    data-testid="project-pin"
  >
    <Pin size={13} aria-hidden />
    {pinned ? 'Pinned' : 'Pin'}
  </Button>
)
